
  import createMeisterIcons from '../src/createMeisterIcons';

  const Nav = createMeisterIcons("nav", [["g",{"clip-path":"url(#a)","key":"63670831ff88d89a1fc36ddc091eb68aa4cbb847","fillRule":"evenodd","clipRule":"evenodd"}],["defs",{"key":"e1d3aa5d01cbf7d36ca5874c796d774d00f15d94","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Nav
  